var exports = {
  "kL": "ReportFlowSummary.module__container___SHV2ME",
  "ed": "ReportFlowSummary.module__disclaimer___SHV2ME",
  "uW": "ReportFlowSummary.module__section___SHV2ME",
  "R_": "ReportFlowSummary.module__heading___SHV2ME",
  "GA": "ReportFlowSummary.module__answers___SHV2ME",
  "ZF": "ReportFlowSummary.module__answer___SHV2ME",
  "yy": "ReportFlowSummary.module__answerText___SHV2ME",
};

module.exports = exports;
